/*
 * @Author: zhaofy
 * @Date: 2018-01-25 22:55:56
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-03-11 16:51:13
 */
<template>
  <!-- 商品详情页左边 -->
  <div class="left-card">
    <!-- 搜索部分 -->
    <div class="search card">
      <div class="title">店内搜</div>
      <div class="content">
        <div>
          <span>关键字：</span>
          <input type="text" v-model="keyword" style="width:100px;">
        </div>
        <div>
          <span>价格：</span>
          <input type="number" v-model="price1" style="width:40px;">
          <span>-</span>
          <input type="number" v-model="price2" style="width:40px;">
        </div>
        <a class="btn-search" @click.stop.prevent="cSearch()">搜索</a>
      </div>
    </div>
    <!-- 商品分类 -->
    <div class="classify card">
      <div class="title">商品分类</div>
      <div class="content">
        <div v-for="item in catListData">
          <span @click.stop.prevent="toggle(item)"><em v-show="item.show">-</em><em v-show="!item.show">+</em></span>
          <a @click.stop.prevent="cCatList(item)" :title="item.storeCatName">{{item.storeCatName | limitToNum(10)}}</a>
          <div v-show="item.show">
            <a style="display: block;padding-left: 26px;font-weight: normal;" v-for="item in item.list"
              @click.stop.prevent="cCatList(item)" :title="item.storeCatName"> •
              {{item.storeCatName | limitToNum(10)}}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 推荐部分 -->
    <div class="recommend card">
      <div class="title">店长推荐</div>
      <div v-for="item of recomList" class="rec-goods">
        <div class="poster" @click.stop.prevent="cRecGoods(item)">
          <img :src="item.thumbnail" alt="推荐商品图片">
        </div>
        <div class="name" @click.stop.prevent="cRecGoods(item)">{{item.name}}</div>
        <div class="price"><span></span>{{item.price}}</div>
      </div>
      <div class="btn">
        <div @click.stop.prevent="cOther">查看本店其他商品</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGoodsTag } from '@/api/goods'
import { limitToNum } from 'api/index.js';
export default {
  name: 'card',
  props: {
    storeId: [Number], // 店铺id
    catList: [Array] // 店铺信息
  },
  data() {
    return {
      keyword: '', // 搜索关键字
      price1: '', // 价格输入框1
      price2: '', // 价格输入框2
      catListData: [], // 店铺商品分类列表
      recomList: [] // 店铺推荐列表
    }
  },
  mounted() {
    //  组件传值会存在延时，定时检测storeId是否存在
    let timer = setInterval(() => {
      if (this.storeId !== undefined) {
        this.getRecom();
        clearInterval(timer)
      }
    }, 50)
  },
  watch: {
    // 监听店铺id，切换详情页其他商品，重新请求数据
    storeId() {
      this.getRecom()
    },
    catList() {
      var obj = [];
      var obj2 = [];
      for (var i in this.catList) {
        if (this.catList[i].storeCatPid == 0) {
          obj.push(this.catList[i]);
        } else {
          obj2.push(this.catList[i]);
        }
      }
      for (var k in obj) {
        obj[k].show = true;
        obj[k].list = [];
        for (var j in obj2) {
          if (obj2[j].storeCatPid == obj[k].storeCatId) {
            obj[k].list.push(obj2[j]);
            if (obj[k].list.length) {
              obj[k].show = false;
            }
          }
        }
      }
      const all = {
        list: [],
        show: true,
        sort: 1,
        storeCatId: '0',
        storeCatName: '全部商品',
        storeId: this.storeId
      };
      obj.splice(0, 0, all);
      this.catListData = JSON.parse(JSON.stringify(obj));
    }
  },
  methods: {
    toggle(item) {
      if (item.list.length == 0) return;
      item.show = !item.show;
    },
    // 获取店铺推荐商品
    getRecom() {
      getGoodsTag({
        storeId: this.storeId,
        tagId: 8,
        pageNo: 1,
        pageSize: 5
      }).then(res => {
        if (res.resCode === 1) {
          this.recomList = res.data.goodsList
        }
      })
    },
    // 查看搜索商品
    cSearch() {
      //console.log(this.keyword)
      this.$router.push({ path: '/shop', query: { tab: 2, store_id: this.storeId, keyword: this.keyword, start_price: this.price1, end_price: this.price2 } });
    },
    // 查看分类
    cCatList(item) {
      if (item.storeCatId == '0') {
        this.$router.push({ path: '/shop', query: { tab: 2, store_id: this.storeId, acid: item.storeCatId } });
      } else {
        this.$router.push({ path: '/shop', query: { tab: 2, store_id: this.storeId, pid: item.storeCatPid, acid: item.storeCatId } });
      }
    },
    // 查看推荐商品
    cRecGoods(item) {
      this.$router.push({ path: '/goods', query: { goods_id: item.goods_id } });
    },
    // 查看本店其他商品
    cOther() {
      this.$router.push({ path: '/shop', query: { tab: 2, store_id: this.storeId } });
    }
  }
}
</script>
<style scoped lang="less">
.left-card {
  width: 210px;
  display: block;
  float: left;
  min-height: 500px;
  .card {
    margin-bottom: 10px;
    border: 1px solid #ddd;
    .title {
      background-color: #f7f7f7;
      height: 20px;
      padding: 5px 10px;
      border-bottom: 1px solid #ddd;
    }
  }
  // 搜索部分
  .search {
    .content {
      margin: 5px 13px 10px 5px;
      div {
        height: 32px;
        line-height: 32px;
        span:first-child {
          display: inline-block;
          width: 60px;
          text-align: right;
          padding-right: 8px;
        }
      }
      div input {
        height: 16px;
        line-height: 16px;
        background-color: #f9f9f9;
        padding: 1px 2px 3px 4px;
        border: solid 1px;
        border-color: #ccc #ddd #ddd #ccc;
        box-shadow: 2px 2px 1px 0 #e7e7e7 inset;
        &:hover {
          background-color: #fff;
        }
        &:focus {
          background-color: #fff;
          border-color: #ccc;
          box-shadow: 1px 1px 1px 0 #e7e7e7;
        }
      }
      div:first-child input {
        width: 90px;
      }
      div:nth-child(2) input {
        width: 32px;
      }
      .btn-search {
        margin-top: 2px;
        margin-left: 70px;
        display: inline-block;
        width: 54px;
        height: 26px;
        line-height: 26px;
        border-radius: 4px;
        text-align: center;
        background-color: #d93600;
        color: #fff;
      }
    }
  }
  // 分类部分
  .classify {
    .content {
      width: 170px;
      margin: 5px 13px 5px 15px;
      background: #fff;
      div {
        line-height: 20px;
        font-weight: 600;
        text-align: left;
        margin: 6px 0;
        span {
          display: inline-block;
          font-size: 12px;
          line-height: 10px;
          text-align: center;
          width: 10px;
          height: 10px;
          margin: 5px 10px 5px 0;
          border: solid 1px #ccc;
        }
        a {
          color: #333;
        }
      }
    }
  }
  // 推荐部分
  .recommend {
    .rec-goods {
      position: relative;
      width: 180px;
      height: 50px;
      padding: 8px 12px 8px 4px;
      display: block;
      clear: both;
      margin-top: -1px;
      border-bottom: dashed 1px #e7e7e7;
      .poster {
        position: absolute;
        top: 0;
        left: 0;
        margin: 8px 4px;
        border: solid 1px #e7e7e7;
        height: 48px;
        width: 48px;
        background-color: #fff;
        img {
          margin: 4px;
          height: 40px;
          width: 40px;
        }
      }
      .name,
      .price {
        float: left;
        width: 120px;
        height: 16px;
        margin-left: 60px;
        _margin-left: 30px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
      }
      .name {
        color: #333;
      }
      .name:hover {
        color: #0085cf;
      }
      .price {
        color: #f60;
        font-weight: 600;
        span {
          display: inline-block;
          height: 12px;
          width: 10px;
          background: url(//static.kxymall.com/images/public.png)
            no-repeat 0 -80px;
        }
      }
    }
    .btn {
      width: 130px;
      margin: 10px auto;
      div {
        line-height: 38px;
        color: #333;
        background-color: #fef4b1;
        text-align: center;
        width: 128px;
        height: 38px;
        border: solid 1px #ffd863;
        border-radius: 5px;
        display: inline-block;
        box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.1);
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// module-card.vue?5f01fdc9